import script from "./T3dviewInstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./T3dviewInstruction.vue?vue&type=script&setup=true&lang=js"

import "./T3dviewInstruction.vue?vue&type=style&index=0&id=3eaa1ee5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eaa1ee5"]])

export default __exports__